<template>
	<div>
		<van-overlay :show="showOverlay" z-index="99">
			<div style="position: fixed; top: 50%; left: 50%; z-index: 100; transform: translate(-50%, -50%)"></div>
		</van-overlay>
		<section class="c" :class="is_web_css" v-show="!is_Unclaimed" :style="{ minHeight: windowHight }">
			<div class="jianbian" :style="{ filter: showZhezhao ? 'blur(3px)' : 'none' }">
				<van-form ref="formAddorEdit" class="fromClass">
					<van-field v-model="formData.text1" label="姓名：" placeholder="请填写姓名" :rules="rules.text1" />
					<van-field v-model="formData.text2" label="联系电话：" placeholder="请填写联系电话" :rules="rules.text2" />
					<van-field v-model="formData.text3" label="诊所名称：" placeholder="请填写诊所名称" :rules="rules.text3" />
					<van-field v-model="formData.text4" label="诊所地址：" placeholder="请填写诊所地址" :rules="rules.text4" />
					<van-field v-model="formData.redeemCode" label="兑换码：" placeholder="请输入兑换码" :rules="rules.redeemCode" />
					<div style="margin: 16px">
						<span class="buttonSpan" @click="butClick">登记激活</span>
					</div>
				</van-form>
			</div>
		</section>
		<!-- 提示框 -->
		<div class="zhezhao" v-show="showZhezhao">
			<ul>
				<li class="li1">资料审核中</li>
				<li class="li2">(预计1个工作日)</li>
				<li class="li3">
					<van-divider :style="{ fonstSize: ' 15px', color: '#046C6E', borderColor: '#429193', padding: '0 30px' }">温馨提示</van-divider>
				</li>
				<li class="li4">智慧中医AI舌诊，</li>
				<li class="li5">仅限为专业人士或机构提供辅助诊断。</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { Toast, Dialog } from 'vant';
import axios from 'axios';

export default {
	data() {
		return {
			showOverlay: true, //遮罩
			is_web_css: '',
			// activityId: this.$route.query.id, //活动详情ID
			activityId: '3a9e5dfca37d4fbebaabd6ab4739e038', //正式环境
			// activityId: 'c0a2655674f64f139b2044052b422d88', //测试环境
			aiId: '',
			token: '',
			formData: { text1: '', text2: '', text3: '', text4: '', redeemCode: '' },
			rules: {
				text1: [{ required: true }],
				text2: [{ required: true, pattern: /^1[3456789]\d{9}$/ }],
				text3: [{ required: true }],
				text4: [{ required: true }],
				redeemCode: [{ required: true }],
			},
			is_Unclaimed: true, //是否领取过
			showZhezhao: false,
			windowHight: '100vh',
		};
	},

	mounted() {
		document.title = '智慧中医AI舌诊';
		Toast.loading({
			message: '加载中...',
			duration: 0,
		});
		if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone| harmony)/i)) {
			this.getToken();
			let that = this;
			this.$bridge.registerhandler('refreshList', () => {
				that.getToken();
			});
			// this.token = this.$route.query.webToken;
			// this.getActivityId();
		} else {
			this.token = this.$route.query.webToken;
			this.getActivityId();
			this.is_web_css = 'is_web_css';
		}
	},
	methods: {
		// 获取token
		getToken() {
			let that = this;
			if (navigator.userAgent.indexOf('kcgy') == -1) {
				window.location.href = 'https://app.kcguoyi.com/download/#/';
				return false;
			}
			this.$bridge.callHandler('loadToken', null, (response) => {
				if (response == '' || response.length <= 0) {
					that.$bridge.callHandler('login', null, function (response) {});
					return false;
				}
				that.token = response;
				that.getActivityId();
			});
		},
		//根据活动的详情页ID显示数据
		async getActivityId() {
			var url = process.env.VUE_APP_BASE_API + '/act/page/h5/' + this.activityId;
			await axios.get(url, { headers: { Authorization: 'Bearer ' + this.token, clientOs: 'h5' } }).then(async (res) => {
				if (res.data.code != 200) return false;
				//判断活动是否有效及时间范围内
				var actStartTime = new Date(res.data.data.actStartTime.replace(/-/g, '/')).getTime();
				var actEndTime = new Date(res.data.data.actEndTime.replace(/-/g, '/')).getTime();
				var myDate = new Date().getTime();
				var actStatusCode = res.data.data.actStatusCode; //0 活动正常 1活动不正常
				this.aiId = res.data.data.aiId;
				var is_show = true;
				if (this.is_web_css == '') {
					if (myDate < actStartTime || myDate > actEndTime || actStatusCode == '1') {
						this.$router.replace('/defaultPage');
						return false;
					}
				}
				await axios
					.post(
						process.env.VUE_APP_BASE_API + '/act/questionnaire/h5/selectTongue',
						{ aiId: res.data.data.aiId },
						{
							headers: {
								Authorization: 'Bearer ' + this.token,
								clientOs: 'h5',
							},
						}
					)
					.then((res) => {
						if (res.data.code == 200) {
							is_show = false;
							setTimeout(() => {
								window.location.href = res.data.msg;
							}, 10);
						}
					});
				if (is_show) {
					this.showOverlay = false; //不显示遮罩
					this.is_Unclaimed = false; //是否领取过
					this.$nextTick(() => {
						this.windowHight = window.innerHeight + 'px';
					}, 1000);

					Toast.clear();
				}
			});
		},

		//表单的提交
		butClick() {
			if (this.showZhezhao) return false;
			this.$refs.formAddorEdit
				.validate()
				.then(() => {
					var url = process.env.VUE_APP_BASE_API + '/act/questionnaire/h5/submitTongue';
					var lableData = ['姓名', '联系电话', '诊所名称', '诊所地址', '兑换码'];
					var newJson = {
						aiId: this.aiId,
						...this.formData,
						tableHead: lableData.toString(),
					};
					for (var i = 0; i < lableData.length; i++) {
						if (this.formData[Object.keys(this.formData)[i]].trim() == '') {
							Toast('请填写完整信息后进行兑换！');
							return false;
						}
					}
					this.showZhezhao = true;
					axios.post(url, newJson, { headers: { Authorization: 'Bearer ' + this.token, clientOs: 'h5' } }).then((res) => {
						if (res.data.code == 200) {
							setTimeout(() => {
								window.location.href = res.data.msg;
							}, 5000);
						} else {
							Dialog({ message: res.data.msg });
							this.showZhezhao = false;
						}
					});
				})
				.catch(() => {
					Toast('请填写完整信息');
					this.showZhezhao = false;
				});
		},
	},
};
</script>
<style lang="scss" >
section {
	min-height: 100vh;
	overflow: hidden;
	background-image: url('../image/aisz_back.png');
	background-size: 100% 100%;
	background-repeat: no-repeat;
	position: relative;
}
.c {
	width: 100%;
}
.is_web_css {
	max-width: 375px;
	max-height: 667px;
	margin: 50px auto;
}

.jianbian {
	width: 90%;
	overflow: hidden;
	padding: 8px 10px;
	background-image: url('../image/aisz_bigBox.png');
	background-size: 100% 100%;
	background-repeat: no-repeat;

	position: absolute;
	top: 65%;
	left: 50%;
	transform: translate(-50%, -50%);
}
.fromClass {
	width: 100%;
	// background-color: #ffffff;
	margin: 0 auto;
	border-radius: 10px;
	overflow: hidden;
	padding-top: 15px;
	.van-cell {
		background-color: transparent;
	}
	.van-cell::after {
		border: 0;
	}
	.van-field__label {
		width: 5em;
		line-height: 34px;
		font-size: 13px;
		color: #222222;
		text-align: right;
	}
	.van-field__value {
		overflow: visible;
		padding-left: 10px;
		height: 34px;
		line-height: 34px;
		background-color: #c8fafb;
		border-radius: 7px;
		border: 1px solid #38a0ad;
	}

	.buttonSpan {
		width: 70%;
		display: block;
		text-align: center;
		margin: 0 auto;
		height: 35px;
		line-height: 35px;
		background-color: #046c6e;
		font-size: 14px;
		color: #ffffff;
		border-radius: 19px;
	}
}

.zhezhao {
	position: fixed;
	overflow: hidden;
	width: 90%;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 101;
	background-image: url('../image/aisz_alertBox.png');
	background-size: 100% 100%;
	background-repeat: no-repeat;

	ul {
		text-align: center;
		color: #046c6e;
		.li1 {
			width: 85%;
			display: block;
			margin: 34px auto 0;
			height: 35px;
			line-height: 35px;
			background-color: #046c6e;
			font-size: 14px;
			color: #ffffff;
			border-radius: 19px;
		}
		.li2 {
			margin-top: 6px;
			font-size: 10px;
		}
		.li3 {
			margin-top: 15px;
		}
		.li4 {
			font-size: 13px;
			margin-top: 6px;
		}
		.li5 {
			font-size: 13px;
			margin: 6px 0 33px;
		}
	}
}
</style>